<template>
    <div>
        跳转到开发服
    </div>
</template>

<script>
    // @ is an alias to /src
    import axios from 'axios'
    export default {
        name: 'jumptodevelop',
        components: {},
        mounted() {
            this.$nextTick(() => {
                let code = this.$route.query.code
                if(!code){
                    code = null
                }
                window.location.href = 'https://devwxpa.jianchengjt.com/?code=' + code
            })
        },
        methods: {

        }
    }
</script>
